import request from '@/utils/server'
// 获取菜单
 export function getListMenu(query) {
    return request({
      url: '/menu/getList',
      method: 'get',
      params: query
    })
  }
  // 新增
export function addMenu(data) {
    return request({
      url: '/menu/add',
      method: 'POST',
      data: data
    })
  }
  // 删除
  export function deleteMenu(data) {
    return request({
      url: '/menu/delete',
      method: 'POST',
      data: data
    })
  }
  // 修改
  export function editMenu(data) {
    return request({
      url: '/menu/edit',
      method: 'POST',
      data: data
    })
  }